var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1H1V17H10",
    stroke: "#FF4646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3536 9.35355C17.5488 9.15829 17.5488 8.84171 17.3536 8.64645L14.1716 5.46447C13.9763 5.2692 13.6597 5.2692 13.4645 5.46447C13.2692 5.65973 13.2692 5.97631 13.4645 6.17157L16.2929 9L13.4645 11.8284C13.2692 12.0237 13.2692 12.3403 13.4645 12.5355C13.6597 12.7308 13.9763 12.7308 14.1716 12.5355L17.3536 9.35355ZM6 9.5H17V8.5H6V9.5Z",
    fill: "#FF4646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogoutIcon);
export default __webpack_public_path__ + "static/media/mobileLogoutIcon.00d6dcd9.svg";
export { ForwardRef as ReactComponent };